import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { focusOutline } from '@hivebrite/design-system/Theme';

const DisplayWrapperNoImage = ({ children, rounded = true }) => (
  <Wrapper $rounded={rounded}>{children}</Wrapper>
);

export default DisplayWrapperNoImage;

const Wrapper = styled(Box).attrs(() => ({
  maxHeight: '100%',
  width: '100%',
  maxWidth: '100%',
}))`
  ${focusOutline}
  border-radius: ${({ $rounded }) =>
    $rounded === true ? '4px 4px 0px 0px' : $rounded || '0px'};
`;
